import axios from "axios";
import endpoints from "@/api/endpoints";

export class BreadcrumbsService {
  static __instance = null;

  constructor() {
    if (BreadcrumbsService.__instance) {
      return BreadcrumbsService.__instance;
    }

    BreadcrumbsService.__instance = this;
  }

  getBreadcrumbs(page) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${endpoints.breadcrumbs}?page=${page}`)
        .then(response => {
          if (response.data) {
            return resolve(response.data);
          } else return reject(new Error("Bad response"));
        })
        .catch(err => reject(new Error(err)));
    });
  }
}

export const breadcrumbsService = new BreadcrumbsService();
